import React, { memo, useContext, useMemo } from 'react';
import { useAppSelector } from '../../../redux/app';
import { makeBidAskBySymbolSelector } from '../../../redux/selector';
import { TradeContext } from '../../trading-dialog/context/TradeContextProvider';
import { Button } from '@vt/vt-ui';
import useAuth from '../../../hooks/useAuth';
import useHistorySmartFilter from '../../../hooks/useHistorySmartFilter';

const Buy = memo(({ handleBuySell, digit, symbol }) => {
  const getBidAsk = useMemo(makeBidAskBySymbolSelector, []);
  const ask = useAppSelector((state) => getBidAsk(state, symbol ?? ''));
  return (
    <Button
      variant="primary"
      className="w-full !h-auto !text-[#e5e5e5] !bg-[#28AFFF]"
      onClick={() => handleBuySell(ask)}>
      <div className="p-2">
        <div className="mb-[2px] text-sm font-bold">Buy</div>
        <div className="text-xs">{ask ? ask.ask.toFixed(digit) : (0).toFixed(digit)}</div>
      </div>
    </Button>
  );
});

Buy.displayName = 'Buy';

const Sell = memo(({ handleBuySell, digit, symbol }) => {
  const getBidAsk = useMemo(makeBidAskBySymbolSelector, []);
  const bid = useAppSelector((state) => getBidAsk(state, symbol ?? ''));
  return (
    <Button
      variant="primary"
      className="w-full !h-auto !text-[#e5e5e5] !bg-[#EF4533]"
      onClick={() => handleBuySell(bid)}>
      <div className="p-2">
        <div className="mb-[2px] text-sm font-bold">Sell</div>
        <div className="text-xs">{bid ? bid.bid.toFixed(digit) : (0).toFixed(digit)}</div>
      </div>
    </Button>
  );
});

Sell.displayName = 'Sell';

const RightButtonAction = memo(() => {
  const { activeAccount } = useAuth();
  const { instrumentInfo, handleExecute } = useContext(TradeContext);
  const { fetchAll: fetchHistoryData } = useHistorySmartFilter();
  // makeBidAskBySymbolSelector
  return (
    <div>
      <div style={{ height: '20px' }}></div>
      <Buy
        digit={instrumentInfo?.digit}
        symbol={instrumentInfo?.symbol}
        handleBuySell={async (e) => {
          await handleExecute(0, 200, undefined, e);
          fetchHistoryData(7, activeAccount);
        }}
      />
      <div style={{ height: '16px' }}></div>
      <Sell
        digit={instrumentInfo?.digit}
        symbol={instrumentInfo?.symbol}
        handleBuySell={async (e) => {
          await handleExecute(1, 200, undefined, e);
          fetchHistoryData(7, activeAccount);
        }}
      />
    </div>
  );
});

RightButtonAction.displayName = 'RightButtonAction';

export { RightButtonAction };
